const config = {
  services: {
    admin: {
      endpointName: 'admin',
      base: 'admin',
    },
  },
};
export default config;